import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';

const HomeCategory = (props) => {

    let Category = props.categories.map((post, i)=>{

        let OfferType = '';
        let OfferType2 = '';
        if(post.OFFER_TYPE!=='')
        {
            if(post.OFFER_TYPE=='PER') OfferType = '%';
            if(post.OFFER_TYPE=='DIS') OfferType = '&#8377;';
        }
        
        return (
            <div className="col-6" key={post.ID}>
                <Link to={`/category/${post.ID}`}>
                    <div className="card mb-2">
                        {post.OFFER!='' && <div className="chip off-tags chip-warning"><span className="chip-label">{OfferType2}{post.OFFER}{OfferType} Off</span></div>}
                        <img src={post.IMAGE} className="card-img-top" alt="image" />
                        <div className="card-body pt-07 pb-07 text-center categoryText">
                            <p className="card-text font-size-13 text-dgrey font-weg-500">{post.NAME}</p>
                        </div>
                    </div>
                </Link>
            </div>
        );
    });

    return (
        <div className="section pt-2 pb-2">
            <div className="section-title font-size-17 mb-05 text-sdgrey">Categories
                <Link to="/categories">
                    <span className="badge badge-transparent font-size-10 ht-20 font-weg-500">View All</span>
                </Link>
            </div>
            <div className="row">
                {Category}
            </div>
        </div>
    );
}
  
export default HomeCategory;


// WEBPACK FOOTER //
// ./src/components/HomeCategory.js